import React, { useContext, useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { latestDate } from "../../../../sharedComponent/common";
import CommonDatePicker from "../../../../sharedComponent/CommonDatePicker";
import ApiConfig from "../../../../api/ApiConfig";
import { getWithAuthCall, simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

/* === GREEN :: UI UPDATED (map + sidebar Non Scheduled Trips) === */
const CenterMap = ({ center }) => {
  const map = useMap();
  const valid =
    Array.isArray(center) &&
    center.length === 2 &&
    !isNaN(center[0]) &&
    !isNaN(center[1]);
  useEffect(() => {
    if (valid) map?.setView(center, map?.getZoom());
  }, [center, map, valid]);
  return null;
};

const pinIcon = L.divIcon({
  className: "custom-pin",
  html: `
    <div style="
      width: 20px; height: 28px;
      background: #ff3b30;
      clip-path: path('M10 0 C4 0 0 4 0 10 C0 18 10 28 10 28 C10 28 20 18 20 10 C20 4 16 0 10 0 Z');
      border: 1px solid #b30000;
    "></div>
  `,
  iconSize: [20, 28],
  iconAnchor: [10, 28],
});

/* === GREEN :: derive Non Scheduled Trip ranges from gaps between logged_time === */
const buildNonScheduledRanges = (points, gapMinutes = 30) => {
  if (!Array.isArray(points) || points.length === 0) return [];
  const sorted = [...points]
    .filter((p) => p.logged_time)
    .sort((a, b) => (a.logged_time > b.logged_time ? 1 : -1));
  const ranges = [];
  let segStart = sorted[0]?.logged_time;
  let segPrev = sorted[0]?.logged_time;
  const toSec = (hms) => {
    const [h, m, s] = String(hms).split(":").map(Number);
    return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
  };
  for (let i = 1; i < sorted.length; i++) {
    const cur = sorted[i].logged_time;
    if (toSec(cur) - toSec(segPrev) > gapMinutes * 60) {
      ranges.push({ start: segStart, end: segPrev });
      segStart = cur;
    }
    segPrev = cur;
  }
  if (segStart && segPrev) ranges.push({ start: segStart, end: segPrev });
  return ranges;
};

const UnplannedTripsAutoroutingNew = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [VehicleId, setVehicleId] = useState("");
  const [tripEndDate, setTripEndDate] = useState({ toDayDate: new Date() });
  const [OrderListData, setOrderListData] = useState([]);
  const [selectedRangeIdx, setSelectedRangeIdx] = useState(0);
  const maxDate = new Date();

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    getVehicleList();
  }, []);

  function getVehicleList() {
    getWithAuthCall(ApiConfig.VEHICEL_AVALIVALITY_DROPDAWAN)
      .then((data) => setVehicleList(data?.data || []))
      .catch((err) => console.log("api err", err));
  }

  /* === GREEN :: API INTEGRATED === */
  const fetchReport = () => {
    const body = {
      format: "",
      vehicle_id: VehicleId,
      trip_end_date: latestDate(tripEndDate.toDayDate, "yyyy-MM-dd"),
      trip_start_time: "",
      trip_end_time: "",
      tripLimitMinutes: "",
    };
    setLoading(true);
    simplePostCall(
      ApiConfig.UNPLANNED_TRIPS_AUTOROUTING_REPORT,
      JSON.stringify(body)
    )
      .then((res) => {
        if (res?.result) {
          setOrderListData(res?.listData || []);
          setSelectedRangeIdx(0);
        } else {
          setOrderListData([]);
        }
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  const handleCreateTrip = () => {
    const range = nonScheduledRanges[selectedRangeIdx];
    // Redirect to the create-trip page, carrying the selected vehicle/range context.
    navigate("/EditDispatchTrip", {
      state: {
        vehicle_id: VehicleId,
        trip_date: latestDate(tripEndDate.toDayDate, "yyyy-MM-dd"),
        range,
      },
    });
  };

  const validPoints = OrderListData.filter((p) => {
    const lat = parseFloat(p.latitude);
    const lng = parseFloat(p.longitude);
    return !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
  });

  const center = validPoints[0]
    ? [parseFloat(validPoints[0].latitude), parseFloat(validPoints[0].longitude)]
    : [33.8938, 35.5018];

  const polylinePositions = validPoints.map((p) => [
    parseFloat(p.latitude),
    parseFloat(p.longitude),
  ]);

  const nonScheduledRanges = buildNonScheduledRanges(OrderListData);

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            {/* === GREEN :: filter row (vehicle + date + green Submit) === */}
            <div className="heading">
              <div className="multi-select-1" style={{ flex: 1 }}>
                <Select
                  style={{ height: "40px", width: "100%" }}
                  className="custom-select"
                  placeholder={t("Vehicle list")}
                  value={VehicleId || undefined}
                  onChange={(value) => setVehicleId(value)}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label
                      ?.toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                >
                  {vehicleList?.map((v) => (
                    <Option
                      key={v.vehicle_id}
                      value={v.vehicle_id}
                      label={v.vehicle_number}
                      style={{ color: "rgba(156, 73, 0)" }}
                    >
                      {v.vehicle_number}
                    </Option>
                  ))}
                </Select>
              </div>

              <div
                className="innerSelectBox weekCounter datepicker-main"
                style={{ flex: 1 }}
              >
                <CommonDatePicker
                  dateKey={"toDayDate"}
                  setDate={setTripEndDate}
                  data={tripEndDate}
                  SetPlaceholder={t("Trip End Date")}
                  dataDisbal={maxDate}
                />
              </div>

              <div className="innerSelectBox">
                <button
                  type="button"
                  className="btn btn-success"
                  style={{ height: "40px", minWidth: "120px" }}
                  onClick={fetchReport}
                >
                  {t("Submit")}
                </button>
              </div>
            </div>

            {/* === GREEN :: map + right sidebar === */}
            <div className="row m-0">
              <div className="col-md-9 p-0">
                {loading ? (
                  <Loader />
                ) : (
                  <MapContainer
                    center={center}
                    zoom={13}
                    scrollWheelZoom={true}
                    style={{ height: "70vh", width: "100%" }}
                  >
                    <CenterMap center={center} />
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {polylinePositions.length > 1 && (
                      <Polyline
                        positions={polylinePositions}
                        pathOptions={{ color: "#1e62ff", weight: 4 }}
                      />
                    )}
                    {validPoints.map((p, idx) => (
                      <Marker
                        key={idx}
                        position={[
                          parseFloat(p.latitude),
                          parseFloat(p.longitude),
                        ]}
                        icon={pinIcon}
                      >
                        <Popup>
                          <div>
                            <strong>{t("Reached Time")}:</strong>{" "}
                            {p.logged_time}
                            <br />
                            <strong>{t("Speed")}:</strong> {p.speed}
                            <br />
                            <strong>{t("Running Status")}:</strong>{" "}
                            {p.speed > 0 ? t("Running") : t("Stopped")}
                          </div>
                        </Popup>
                      </Marker>
                    ))}
                  </MapContainer>
                )}
              </div>

              <div className="col-md-3 p-3">
                <h5 className="mb-3">{t("Non Scheduled Trips")}</h5>
                {nonScheduledRanges.length === 0 ? (
                  <p className="text-muted">{t("No ranges available")}</p>
                ) : (
                  nonScheduledRanges.map((r, i) => (
                    <div className="form-check mb-2" key={i}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="nonScheduledTrip"
                        id={`nstrip-${i}`}
                        checked={selectedRangeIdx === i}
                        onChange={() => setSelectedRangeIdx(i)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`nstrip-${i}`}
                      >
                        {r.start} - {r.end}
                      </label>
                    </div>
                  ))
                )}
                <button
                  type="button"
                  className="btn btn-success mt-3"
                  onClick={handleCreateTrip}
                  disabled={nonScheduledRanges.length === 0}
                >
                  {t("Create Trip")}
                </button>
              </div>
            </div>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default UnplannedTripsAutoroutingNew;
